import { Badge } from "@shared/ui/badge";
import { Calendar, Wrench } from "lucide-react";
import React from "react";

interface ServicePaymentCardProps {
  servicePayment: any;
  isSelected: boolean;
  onToggle: (servicePaymentId: string) => void;
  currency: string;
}

export const ServicePaymentCard: React.FC<ServicePaymentCardProps> = ({
  servicePayment,
  isSelected,
  onToggle,
  currency,
}) => {
  return (
    <div
      className={`border rounded-lg p-4 cursor-pointer transition-all ${
        isSelected
          ? "border-blue-500 bg-blue-50"
          : "border-gray-200 hover:border-gray-300"
      }`}
      onClick={() => onToggle(servicePayment.id)}
    >
      <div className="flex items-start gap-3">
        {/* Icon */}
        <div className="flex-shrink-0">
          <div className="w-10 h-10 rounded bg-blue-100 flex items-center justify-center">
            <Wrench className="w-5 h-5 text-blue-600" />
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between mb-2">
            <div className="space-y-1">
              <h4 className="font-semibold text-gray-900">
                {servicePayment.utilitySupportName || "N/A"}
              </h4>
              <p className="text-sm font-medium text-blue-600">
                {servicePayment.requestNo || "N/A"}
              </p>
            </div>
            <span className="text-lg font-bold text-gray-900">
              {currency} {servicePayment.serviceCharge || "0.00"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
